import React, { Component } from 'react';
import { AreaChart, Area, BarChart, Bar, Legend, Tooltip, CartesianGrid, XAxis, YAxis, ResponsiveContainer} from 'recharts';
import {ButtonGroup, Button} from 'reactstrap';


class Graphs extends Component {


    constructor(props) {
        super(props);
        this.state = {
            stats: 'none',
            quickStats: 'none',
            currentMetric: 'RFP'
        };


        this.quickStatsCall = this.quickStatsCall.bind(this);
        this.changeMetric = this.changeMetric.bind(this);
        this.quickStatsCall();
    }

    quickStatsCall(){


        fetch('https://dev.iondeveloper.com/api/rep/quickstats/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"get_quick_stats"
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            this.setState({
                quickStats: data.data
            });
        }.bind(this));


        fetch('https://dev.iondeveloper.com/api/rep/quickstats/?api_key=92d466ce-8ba7-4a79-9992-639c4634456a', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method":"get_year_comparison"
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            this.setState({
                stats: data
            });
        }.bind(this));
    }

    changeMetric(e){
        this.setState({
            currentMetric: e.target.value
        });
    }


    render() {


        if (this.state.stats === 'none'){
            return (
                <div>
                    <div className="loader">Loading...</div>
                </div>
            );
        } else {


            let now = new Date();
            let start = new Date(now.getFullYear(), 0, 0);
            let diff = (now - start) + ((start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000);
            let oneDay = 1000 * 60 * 60 * 24;
            let day = Math.floor(diff / oneDay);


            let rfp = [];
            for (let i = 0; i < this.state['stats'][this.state.currentMetric]['lastYear'].length; i++){
                if (i <= day){
                    rfp.push({name: i, lastYear: this.state['stats'][this.state.currentMetric]['lastYear'][i], thisYear: this.state['stats'][this.state.currentMetric]['thisYear'][i]});
                } else {
                    rfp.push({name: i, lastYear: this.state['stats'][this.state.currentMetric]['lastYear'][i]});
                }

            }

            let percentage = Math.round((this.state['stats'][this.state.currentMetric]['thisYear'][day] / this.state['stats'][this.state.currentMetric]['lastYear'][day]) * 100);

         

            // const today = [
            //     {name: 'RFP', Today: this.state.stats['rfp']['today']['totals']['RFP'], Yesterday: this.state.stats['rfp']['yesterday']['totals']['RFP']},
            //     {name: 'CON', Today: this.state.stats['rfp']['today']['totals']['CON'], Yesterday: this.state.stats['rfp']['yesterday']['totals']['CON']},
            //     {name: 'INS', Today: this.state.stats['rfp']['today']['totals']['INS'], Yesterday: this.state.stats['rfp']['yesterday']['totals']['INS']},
            //     {name: 'PTO', Today: this.state.stats['rfp']['today']['totals']['PTO'], Yesterday: this.state.stats['rfp']['yesterday']['totals']['PTO']},
            //     {name: 'KW',  Today: this.state.stats['rfp']['today']['totals']['KW'],  Yesterday: this.state.stats['rfp']['yesterday']['totals']['KW'] }
            // ];
            

            // let week = [];
            // if (this.state.quickStats['rfp']['thisWeek']['totals'] == null){
            //     week = [
            //         {name: 'RFP', ThisWeek: 0, LastWeek: this.state.quickStats['rfp']['lastWeek']['totals']['RFP']},
            //         {name: 'CON', ThisWeek: 0, LastWeek: this.state.quickStats['rfp']['lastWeek']['totals']['CON']},
            //         {name: 'INS', ThisWeek: 0, LastWeek: this.state.quickStats['rfp']['lastWeek']['totals']['INS']},
            //         {name: 'PTO', ThisWeek: 0, LastWeek: this.state.quickStats['rfp']['lastWeek']['totals']['PTO']},
            //         {name: 'KW',  ThisWeek: 0,  LastWeek: this.state.quickStats['rfp']['lastWeek']['totals']['KW'] }
            //     ];
            // } else {
            //     week = [
            //         {name: 'RFP', ThisWeek: this.state.quickStats['rfp']['thisWeek']['totals']['RFP'], LastWeek: this.state.quickStats['rfp']['lastWeek']['totals']['RFP']},
            //         {name: 'CON', ThisWeek: this.state.quickStats['rfp']['thisWeek']['totals']['CON'], LastWeek: this.state.quickStats['rfp']['lastWeek']['totals']['CON']},
            //         {name: 'INS', ThisWeek: this.state.quickStats['rfp']['thisWeek']['totals']['INS'], LastWeek: this.state.quickStats['rfp']['lastWeek']['totals']['INS']},
            //         {name: 'PTO', ThisWeek: this.state.quickStats['rfp']['thisWeek']['totals']['PTO'], LastWeek: this.state.quickStats['rfp']['lastWeek']['totals']['PTO']},
            //         {name: 'KW',  ThisWeek: this.state.quickStats['rfp']['thisWeek']['totals']['KW'],  LastWeek: this.state.quickStats['rfp']['lastWeek']['totals']['KW'] }
            //     ];
            // }




            // const month = [
            //     {name: 'RFP', ThisMonth: this.state.quickStats['rfp']['thisMonth']['totals']['RFP'], LastMonth: this.state.quickStats['rfp']['lastMonth']['totals']['RFP']},
            //     {name: 'CON', ThisMonth: this.state.quickStats['rfp']['thisMonth']['totals']['CON'], LastMonth: this.state.quickStats['rfp']['lastMonth']['totals']['CON']},
            //     {name: 'INS', ThisMonth: this.state.quickStats['rfp']['thisMonth']['totals']['INS'], LastMonth: this.state.quickStats['rfp']['lastMonth']['totals']['INS']},
            //     {name: 'PTO', ThisMonth: this.state.quickStats['rfp']['thisMonth']['totals']['PTO'], LastMonth: this.state.quickStats['rfp']['lastMonth']['totals']['PTO']},
            //     {name: 'KW',  ThisMonth: this.state.quickStats['rfp']['thisMonth']['totals']['KW'],  LastMonth: this.state.quickStats['rfp']['lastMonth']['totals']['KW'] }
            // ];

            // const quarter = [
            //     {name: 'RFP', ThisQuarter: this.state.quickStats['rfp']['thisQuarter']['totals']['RFP'], LastQuarter: this.state.quickStats['rfp']['lastQuarter']['totals']['RFP']},
            //     {name: 'CON', ThisQuarter: this.state.quickStats['rfp']['thisQuarter']['totals']['CON'], LastQuarter: this.state.quickStats['rfp']['lastQuarter']['totals']['CON']},
            //     {name: 'INS', ThisQuarter: this.state.quickStats['rfp']['thisQuarter']['totals']['INS'], LastQuarter: this.state.quickStats['rfp']['lastQuarter']['totals']['INS']},
            //     {name: 'PTO', ThisQuarter: this.state.quickStats['rfp']['thisQuarter']['totals']['PTO'], LastQuarter: this.state.quickStats['rfp']['lastQuarter']['totals']['PTO']},
            //     {name: 'KW',  ThisQuarter: this.state.quickStats['rfp']['thisQuarter']['totals']['KW'],  LastQuarter: this.state.quickStats['rfp']['lastQuarter']['totals']['KW'] }
            // ];

            // const year = [
            //     {name: 'RFP', ThisYear: this.state.quickStats['rfp']['thisYear']['totals']['RFP'], LastYear: this.state.quickStats['rfp']['lastYear']['totals']['RFP']},
            //     {name: 'CON', ThisYear: this.state.quickStats['rfp']['thisYear']['totals']['CON'], LastYear: this.state.quickStats['rfp']['lastYear']['totals']['CON']},
            //     {name: 'INS', ThisYear: this.state.quickStats['rfp']['thisYear']['totals']['INS'], LastYear: this.state.quickStats['rfp']['lastYear']['totals']['INS']},
            //     {name: 'PTO', ThisYear: this.state.quickStats['rfp']['thisYear']['totals']['PTO'], LastYear: this.state.quickStats['rfp']['lastYear']['totals']['PTO']},
            //     {name: 'KW',  ThisYear: this.state.quickStats['rfp']['thisYear']['totals']['KW'],  LastYear: this.state.quickStats['rfp']['lastYear']['totals']['KW'] }
            // ];

            return (
                <div>

                    <div className="button-group-container">
                        <ButtonGroup>
                            <Button className={this.state.currentMetric === 'RFP' ? 'active' : ''} value="RFP" onClick={this.changeMetric}>RFP</Button>
                            <Button className={this.state.currentMetric === 'CON' ? 'active' : ''} value="CON" onClick={this.changeMetric}>CON</Button>
                            <Button className={this.state.currentMetric === 'INS' ? 'active' : ''} value="INS" onClick={this.changeMetric}>INS</Button>
                            <Button className={this.state.currentMetric === 'PTO' ? 'active' : ''} value="PTO" onClick={this.changeMetric}>PTO</Button>
                            <Button className={this.state.currentMetric === 'KW' ? 'active' : ''} value="KW" onClick={this.changeMetric}>KW</Button>
                        </ButtonGroup>
                    </div>

                    <div className="graph-container">
                        <h6 className="graph-label">Percentage of last year: <b>{percentage}%</b></h6>
                        <ResponsiveContainer width="100%" height={400}>
                            <AreaChart width={502} height={250} data={rfp}>
                                <Tooltip />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Area dataKey='thisYear' stroke='#accbed' strokeWidth={3}  fillOpacity={.4}  fill="#accbed" activeDot={{r: 6}} />
                                <Area dataKey='lastYear' stroke='#ffccb8' strokeWidth={3} fillOpacity={.1}  fill="#ffccb8" activeDot={{r: 6}} />
                                <CartesianGrid strokeDasharray="1 1" />
                            </AreaChart>
                        </ResponsiveContainer>
                    </div>

                    {/* <div className="table-holder">
                        <div className="quickStatsTable">
                            <ResponsiveContainer width="100%" height={250}>
                                <BarChart data={today}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="Today" fill="#accbed" />
                                    <Bar dataKey="Yesterday" fill="#ffccb8" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                        <div className="quickStatsTable">
                            <ResponsiveContainer width="100%" height={250}>
                                <BarChart data={week}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="ThisWeek" fill="#accbed" />
                                    <Bar dataKey="LastWeek" fill="#ffccb8" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                        <div className="quickStatsTable">
                            <ResponsiveContainer width="100%" height={250}>
                                <BarChart data={month}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="ThisMonth" fill="#accbed" />
                                    <Bar dataKey="LastMonth" fill="#ffccb8" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>

                    <div className="table-holder">
                        <div className="quickStatsTable">
                            <ResponsiveContainer width="100%" height={250}>
                                <BarChart data={quarter}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="ThisQuarter" fill="#accbed" />
                                    <Bar dataKey="LastQuarter" fill="#ffccb8" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                        <div className="quickStatsTable">
                            <ResponsiveContainer width="100%" height={250}>
                                <BarChart data={year}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="ThisYear" fill="#accbed" />
                                    <Bar dataKey="LastYear" fill="#ffccb8" />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div> */}

                </div>
            )



        }


    }







}


export default Graphs;


// WEBPACK FOOTER //
// ./src/components/shared/Graphs.js